import { render, staticRenderFns } from "./Invitefriend.vue?vue&type=template&id=ac7f0600&"
import script from "./Invitefriend.vue?vue&type=script&lang=js&"
export * from "./Invitefriend.vue?vue&type=script&lang=js&"
import style0 from "./Invitefriend.vue?vue&type=style&index=0&id=ac7f0600&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports